<template>
  <div>
    <div class="main-content-container container-fluid px-4">
    	<div>
    		<div class="page-header row no-gutters py-4">
    			<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
            <span class="text-uppercase page-subtitle">Centro de Mensajes</span>
            <h3 class="page-title">Visión general</h3>
    		  </div>
    	  </div>

        <div class="row">

          <div class="col-lg-12" v-for="(message, index) in messages" :key="index">
            <div class="card card-small card-post mb-4">
              <div class="card-body">
                <p class="card-text text-muted">
                  {{ message.message }}
                </p>
              </div>
              <div class="card-footer border-top d-flex">
                <div class="card-post__author d-flex">
                  <a href="#" class="card-post__author-avatar card-post__author-avatar--small" style="background-image: url('/images/avatars/unknown-user.png');">Written by James Khan</a>
                  <div class="d-flex flex-column justify-content-center ml-3">
                    <span class="card-post__author-name">
                      {{ message.names }} {{ message.lastnames }}
                    </span>
                    <small class="text-muted">
                      <convert-date :date="message.created_at"/>
                    </small>
                  </div>
                </div>
                <div class="my-auto ml-auto">
                  <a class="btn btn-sm btn-white" :href="'mailto:' + message.email">
                    <i class="fas fa-envelope"></i> Contactar </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        messages: []
      }
    },

    mounted() {
      this.getMessages();
    },

    methods: {
      async getMessages() {
        let url = process.env.VUE_APP_ROOT_API.concat('/contact');
        let response = await fetch(url);
        this.messages = await response.json();
      },

      deleteOption(index, id) {
        const message = '¿Estás seguro de querer eliminar este mensaje?';
        const options = {
          okText: 'Sí',
          cancelText: 'No'
        };
        let that = this;
        this.$dialog
          .confirm(message, options)
          .then(function(dialog) {
            that.deleteMessage(index, id);
          });
      },

      async deleteMessage(index, id) {
        let url = process.env.VUE_APP_ROOT_API.concat(`/contact/${id}`);
        let settings = {
          method: 'DELETE'
        };
        let response = await fetch(url, settings);
        switch (response.status) {
          case 200:
            this.messages.splice(index, 1);
            break;
        }
      }
    }
  }
</script>